// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'payslips',
        component: () =>
            import('@/pages/[organisation]/hr/team-member-payslips/payslips.vue'),
        name: 'human-resource.team-member-payslips.search-pay-slips',
        meta: {
            loginRequired: true,
            permission: 'team-member-payslip.read',
        },
    },
];
